import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { base_url } from "../Api/Api";
import SwiperCore, { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Skeleton from "@material-ui/lab/Skeleton";

import Itemnews from "./ItemNews";
import CardGlobal from "./CardGlobal";
SwiperCore.use([Pagination]);

const Mainpage = (props) => {
  const [state, setState] = useState({
    learningItems: [],
    statusShowe: false,
    skltnCount: [1, 2, 3, 4, 5, 6],
  });
  const [data, setData] = useState([]);

  useEffect(() => {
    window.scroll(0, 0);

    base_url
      .get(`indexPage`)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
            localStorage.clear();
            window.location.reload();
          }
        }
      });
  }, []);

  return (
    <>
      {state.statusShowe ? null : (
        <div className="homepage">
          <div className="advertise contain">
            <div className="advertisement">
              <img src="./img/my-exams.svg"></img>
              <Link to="/examList" className="ads-name">
                <span>آزمون های من</span>
              </Link>
            </div>
            <div className="advertisement">
              <img src="./img/how-to-monetize-your-webinar-content.svg"></img>
              <Link to="/Webinar" className="ads-name">
                <span>وبینارهای من</span>
              </Link>
            </div>
            <div className="advertisement">
              <img src="./img/Best_Email_Marketing_Tutorial_Course_Training_Certification_Online.svg"></img>
              <Link to="/recomandationCourses" className="ads-name">
                <span>کورس های پیشنهادی</span>
              </Link>
            </div>
          </div>
          {data.length == 0 ? (
            <div className="baner-lastnews contain">
              <h4>آخرین خبر</h4>
              <a></a>
            </div>
          ) : data.lastNews == null ? null : (
            <div className="baner-lastnews contain">
              <h4>آخرین خبر</h4>
              <Link to={`/news/inner-page/${data.lastNews.id}`}>
                <h4>{data.lastNews.title}</h4>
                <img src={data.lastNews.image} />
              </Link>
            </div>
          )}

          {data.length == 0 ? (
            <div className="education-course contain">
              <div className="title">
                <span>محتوای آموزشی</span>
              </div>
              <Swiper
                spaceBetween={0}
                slidesPerView={3}
                pagination={{ clickable: true }}
              >
                {state.skltnCount.map((item) => (
                  <SwiperSlide>
                    <div className="skltn">
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        width={95 + "%"}
                        height={333}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          ) : data.learningItems.length == 0 ? null : (
            <div className="education-course contain">
              <div className="title">
                <span>محتوای آموزشی</span>
              </div>
              <Swiper
                spaceBetween={0}
                slidesPerView={3}
                pagination={{ clickable: true }}
              >
                {data.learningItems.map((info) => (
                  <SwiperSlide>
                    <div className="borderd-card">
                      <CardGlobal
                        key={info.id}
                        id={info.id}
                        image={info.image}
                        title={info.title}
                        tags={info.tags}
                        date={info.created_at}
                        comment={info.comment_count}
                        link={`/education/category/${info.id}/home`}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Mainpage;
